/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import firebase from 'firebase';
import ProgressCircle from '../ProgressCircle';
import { calculateCommission } from '../../utils/calculateCommission';

export default function Payment({ data, refreshCallback, paid }) {
  const [loading, setLoading] = useState(false)

  const onClick = async () => {
    if (!paid) {
      await undo()
    } else {
      await done()
    }
  }

  const done = async () => {
    setLoading(true)
    try {
      const result = await firebase.functions().httpsCallable('updatePayment')({
        payment_id: data.id,
        status: "paid",
        data: data,
      });
      if (!result.data?.result) {
        alert(result.data?.message)
        console.log(result.data);
      }
    } catch (err) {
      alert(err)
    }
    refreshCallback && refreshCallback()
    setLoading(false)
  }

  const undo = async () => {
    setLoading(true)
    try {
      const result = await firebase.functions().httpsCallable('updatePayment')({
        payment_id: data.id,
        status: "to_pay",
        data: data,
      });
      if (!result.data?.result) {
        alert(result.data?.message)
        console.log(result.data);
      }
    } catch (err) {
      alert(err)
    }
    refreshCallback && refreshCallback()
    setLoading(false)
  }

  return (
    <div className="card gap-2 d-flex p-3 mb-4 shadow m-2">
      {loading ? <ProgressCircle /> :
        <>
          <div className="mb-3">
            {/* <h4 className="flex-fill">Title of the product</h4> */}
            <a className="flex-fill" href={`/p/${data?.uid}`}>{data?.username ? `@${data?.username}` : '[NO_USERNAME]'}</a>
            <p className="card p-1 m-0 mt-1">
              <b> Bank number:</b> {data?.bank_details || '[NO_BANK_DETAILS]'}
            </p>
            {data?.tags?.includes('delivery-success') && <>
              <p className="card p-1 m-0 mt-1">
                <b>To Pay:</b> {data?.price ? `${calculateCommission(parseFloat(data?.price))?.receive?.toFixed(2)} ₾` : '[NO_PRICE]'}
              </p>
              <p className="card p-1 m-0 mt-1">
                <b>Fee:</b> {data?.price ? `${calculateCommission(parseFloat(data?.price))?.fee?.toFixed(2)} ₾` : '[NO_PRICE]'}
              </p>
            </>}
            <p className="card p-1 m-0 mt-1">
              <b>Total:</b> {data?.price ? `${parseFloat(data.price).toFixed(2)} ₾` : '[NO_PRICE]'}
            </p>
            <p className="card p-1 m-0 mt-1">
              <b>Name, Last Name:</b> {data.fullUserName || '[NO_NAME]'}
            </p>
            <div>
              {data?.tags?.map((tag, index) => {
                return <span key={index} style={{ marginRight: 4 }} className="label label-danger">{tag}</span>
              })}
            </div>
          </div>
          <button onClick={onClick} className="btn btn-dark flex-fill">{!paid ? "Mark as paid" : "Undo"}</button>
          <small>{(new Date(data?.created_at)?.toTimeString())}</small>
        </>}
    </div>
  );
}
